import { render } from "./AssetType_Rooms.vue?vue&type=template&id=954f68cc&ts=true"
import script from "./AssetType_Rooms.vue?vue&type=script&lang=ts"
export * from "./AssetType_Rooms.vue?vue&type=script&lang=ts"

import exportComponent from "/data/jenkins/workspace/PROD/SwissApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__